import React, { useState } from 'react';
import type { MenuProps } from 'antd';
import { Menu } from 'antd';

type MenuItem = Required<MenuProps>['items'][number];

const items: MenuItem[] = [
  {
    label: 'แบรนด์',
    key: 'brand',
  },
  {
    label: 'แคตตากอรี่',
    key: 'catalog',
  },
  {
    label: 'สินค้า',
    key: 'product',
  },
  {
    label: 'สินค้าคงเหลือ',
    key: 'stock',
  },
  {
    label: 'คำสั่งซื้อ',
    key: 'order',
  },
];

const MasterMenu: React.FC<{ onchange: (key?: string) => void }> = ({
  onchange,
}) => {
  const [current, setCurrent] = useState('brand');

  const onClick: MenuProps['onClick'] = e => {
    setCurrent(e.key);
    onchange(e.key);
  };

  return (
    <Menu
      onClick={onClick}
      selectedKeys={[current]}
      mode="horizontal"
      items={items}
    />
  );
};

export default MasterMenu;
